var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__search"},[_c('input',{staticClass:"input mobile-full",attrs:{"type":"text","placeholder":_vm.$t('emailsList.searchPlaceholder')},on:{"input":_vm.searchCapturedEmails}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d8dd3e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Emails/components/Search.vue
// module id = 1473
// module chunks = 1